import { Box } from '@mui/material';
import React from 'react';

function Bullet() {
  return (
    <Box
      component="span"
      sx={theme => ({ display: 'inline-block', mx: '2px', transform: 'scale(0.8)', color: theme.palette.primary.main })}
    >
      •
    </Box>
  );
}

export default Bullet;
